import { gql } from '__generated__';

export default gql(`
  mutation DeleteEvent($id: ID!) {
    deleteEvent(id: $id)
  }
`);
